/**
 * Só `http:` e `https:` podem sair daqui.
 *
 * O motivo é concreto: o link de redirecionamento da etapa de finalização vai
 * direto pra `window.location.href` no preenchimento público. Sem checar o
 * esquema, quem edita o formulário grava `javascript:...` e o código roda no
 * navegador de qualquer visitante, na origem da aplicação — onde mora o token
 * de sessão. `data:` e `blob:` entregam o mesmo resultado por outro caminho.
 *
 * Não confundir com `normalizeNotificationUrl`/`isInternalAppUrl`: aqueles
 * tratam rota INTERNA do SPA. Aqui é o oposto — permitir link externo de
 * verdade, barrando só os esquemas executáveis.
 */
const ESQUEMAS_PERMITIDOS = ['http:', 'https:'];

/**
 * @param {string | null | undefined} rawUrl
 * @returns {string | null} a URL normalizada, ou `null` se não for navegável
 */
export const safeExternalUrl = (rawUrl) => {
  if (!rawUrl || typeof rawUrl !== 'string') return null;

  const trimmed = rawUrl.trim();
  if (!trimmed) return null;

  try {
    // Sem base: URL relativa (`/algo`, `algo.com`) é rejeitada de propósito —
    // o campo é "abrir link" externo, e um caminho relativo aqui é engano do
    // usuário, não intenção.
    const parsed = new URL(trimmed);
    return ESQUEMAS_PERMITIDOS.includes(parsed.protocol) ? parsed.href : null;
  } catch {
    return null;
  }
};

export default safeExternalUrl;
